import type { DonutData, Ring } from '@fleet/shared';
import { RingCircle } from '../../components/charts/RingCircle';
import { Eyebrow } from '../../components/ui/Eyebrow';
import { Panel } from '../../components/ui/Panel';

function RingCard({
  ring,
  title,
  centerColor,
  delay,
  voet,
}: {
  ring: Ring;
  title: string;
  centerColor: string;
  delay: number;
  /** One extra line under the segments, for a figure that qualifies them. */
  voet?: string;
}) {
  return (
    <Panel style={{ display: 'flex', alignItems: 'center', gap: 20, padding: '22px 24px' }}>
      <RingCircle
        segments={ring.segments}
        center={ring.center}
        centerSub={ring.centerSub}
        centerColor={centerColor}
        animationDelay={delay}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, minWidth: 0 }}>
        <Eyebrow>{title}</Eyebrow>
        {ring.segments.map((s) => (
          <div
            key={s.label}
            style={{ display: 'flex', alignItems: 'center', gap: 9, fontSize: 13 }}
          >
            <span
              style={{ width: 11, height: 11, borderRadius: 3, background: s.color, flex: 'none' }}
            />
            <span style={{ color: '#444444', flex: 1 }}>{s.label}</span>
            <span style={{ fontWeight: 900, color: '#111111' }}>{s.count}</span>
          </div>
        ))}
        {voet && <div style={{ fontSize: 11.5, color: '#888888', lineHeight: 1.5 }}>{voet}</div>}
      </div>
    </Panel>
  );
}

export function FleetRings({
  fleet,
  drivetrain,
  eigendom,
  donut,
}: {
  fleet: Ring;
  drivetrain: Ring;
  eigendom: Ring;
  /** Variable spend split by drivetrain, for the share-of-cost line. */
  donut: DonutData;
}) {
  // Twee percentages over elektrisch op één pagina spreken elkaar tegen zolang er
  // niet bij staat waarover ze gaan. Naast elkaar zeggen ze juist iets: minder
  // aandeel in de kosten dan in de vloot betekent dat elektrisch goedkoper rijdt.
  const kostenDeel = donut.ev + donut.ice > 0 ? donut.evPct : null;

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 16,
      }}
    >
      <RingCard ring={fleet} title="Wagenpark" centerColor="#111111" delay={0} />
      <RingCard
        ring={drivetrain}
        title="Aandrijving"
        centerColor="#2A6085"
        delay={0.1}
        voet={kostenDeel == null ? undefined : `${kostenDeel}% van de variabele kosten`}
      />
      <RingCard ring={eigendom} title="Eigendom" centerColor="#2A6085" delay={0.2} />
    </div>
  );
}
